import template from '../../view/overview.html';

export default {
    render: template.render,
    staticRenderFns: template.staticRenderFns
};



// WEBPACK FOOTER //
// ./src/script/view/overview.js